'use strict'
/**
 * 上传头像
 * zlh
 */
import Blockly from '@/assets/blockly/renderers/index.js'
//项目接口
import AI_EDITOR from '@/axios/personalSpace/AiEditor/blocks.js'
//实训接口
import BLOCK from '@/axios/trainingCenter/AiEditor/blocks.js'
//上传文件等公共接口
import COMMON from '@/axios/common/common.js'

export const MediaBlocks = {
  data() {
    return {
      picTempList: [], //图片积木缓存
      camTempList: [], //摄像头积木缓存
      audioTempList: [], //摄像头积木缓存
      textTempList: [], //文本积木缓存
      renamePicObj: {}, //缓存重命名的图片积木
      renameCamObj: {}, //缓存重命名的摄像头积木
      renameAudioObj: {}, //缓存重命名的音频积木
      renameTextObj: {}, //缓存重命名的文本积木
      photoBaseUrl: window.gtaAiConfig.photoDomain, // 资源平台上传基地址（代理）
      fileBaseUrl: window.gtaAiConfig.fileBaseUrl, // 资源平台上传基地址

    }
  },
  watch: {
    Media(Media) {
      // 将媒体图片数据放到图片变量图片取现点
      let self = this
      let reg_base_url = new RegExp(this.photoBaseUrl)
      let mediaFiles =
          Media.length > 0
            ? Media.map((item) => {
                let mediaFileUrl
                if (reg_base_url.test(item.mediaFileUrl)) {
                  mediaFileUrl = item.mediaFileUrl
                } else {
                  let  reg_rtsp = /(rtsp|rtmp):/;
                  if(reg_rtsp.test(item.mediaFileUrl)){
                    //摄像头积木不用拼接基地址
                    mediaFileUrl =item.mediaFileUrl
                  }else{
                    //其他媒体积木要拼接基地址
                    mediaFileUrl = self.photoBaseUrl + item.mediaFileUrl
                  }
                }
                return {
                  mediaFileUrl: mediaFileUrl,
                  mediaFileName: item.mediaFileName,
                }
              })
            : [],
        picTempList = JSON.parse(JSON.stringify(this.picTempList)),
        camTempList = [],
        audioTempList = JSON.parse(JSON.stringify(this.audioTempList)),
        textTempList = JSON.parse(JSON.stringify(this.textTempList))

      if (Media.length < 0) {
        return
      }

      mediaFiles.forEach(function(file) {
        // mediaFiles.forEach(function toPicTempList(file) {
        let pic_match = /.jpeg|.png|.jpg|.svg/i
        let audio_match = /.WMA|.mp3|.wav|.wma|.ape|.flac|.ogg|.aac|.m4a/i
        let text_match = /.txt/i

        var hasItem = false
        var hasAudioItem = false
        var hasTextItem = false
        picTempList.find((item) => {
          if (item.mediaFileUrl == file.mediaFileUrl) {
            hasItem = true
          }
        })
        audioTempList.find((item) => {
          if (item.mediaFileUrl == file.mediaFileUrl) {
            hasAudioItem = true
          }
        })
        textTempList.find((item) => {
          if (item.mediaFileUrl == file.mediaFileUrl) {
            hasTextItem = true
          }
        })
        // 图片列表
        if (
          !hasItem &&
          (/^(https?:\/\/)/.test(file.mediaFileUrl) || file.mediaFileUrl.indexOf('service_photoDomain') !== -1) &&
          pic_match.test(file.mediaFileUrl)
        ) {
          picTempList.push(file)
        }
        //摄像头列表
        if (
          !hasItem &&
          (
            file.mediaFileUrl.indexOf('rtsp:') != -1 ||
            file.mediaFileUrl.indexOf('rtmp:') != -1 ||
            /.m3u8$/.test(file.mediaFileUrl))
        ) {
          camTempList.push(file)
        }
        // 音频列表
        if (
          !hasAudioItem &&
          (/^(https?:\/\/)/.test(file.mediaFileUrl) || file.mediaFileUrl.indexOf('service_photoDomain') !== -1) &&
          audio_match.test(file.mediaFileUrl)
        ) {
          audioTempList.push(file)
        }
        // 文本列表
        if (
          !hasTextItem &&
          (/^(https?:\/\/)/.test(file.mediaFileUrl) || file.mediaFileUrl.indexOf('service_photoDomain') !== -1) &&
          text_match.test(file.mediaFileUrl)
        ) {
          textTempList.push(file)
        }
      })

      if (picTempList.length > this.picTempList.length) {
        this.picTempList = picTempList
      }
      camTempList = this.reduceMediaArr(camTempList)
      this.camTempList = camTempList
      if (audioTempList.length > this.audioTempList.length) {
        this.audioTempList = audioTempList
      }
      if (textTempList.length > this.textTempList.length) {
        this.textTempList = textTempList
      }
    },
    picTempList: {
      handler(list) {
        // console.log('picTempList', list)
        //缓存的图片积木监听
        var picAddedList = []
        if (!this.mediaGotten) {
          //检验数据库有没有返回-可能不需要判断数据库有没有返回
          return
        }

        list.forEach((picTemp) => {
          let findMedia = this.Media.find(
            (item) => item && item.mediaFileUrl === picTemp.mediaFileUrl
          )
          // 如果从数据库中存取中没有的图片信息，则进行上传
          if (!findMedia) {
            picAddedList[picAddedList.length] = picTemp
          }
        })
        // 图片添加到数据库
        this.reduceArr(picAddedList) //去重
      },
      deep: true,
    },
    audioTempList(audioTempList) {
      //缓存的音频积木监听
      var picAddedList = []
      if (!this.mediaGotten) {
        //检验数据库有没有返回
        return
      }
      audioTempList.forEach((audioTemp) => {
        let findMedia = this.Media.find(
          (item) => item && item.mediaFileUrl === audioTemp.mediaFileUrl
        )
        // 如果从数据库中存取中没有的图片信息，则进行上传
        if (!findMedia) {
          picAddedList[picAddedList.length] = audioTemp
        }
      })
      this.reduceArr(picAddedList) //去重
    },
    textTempList(list) {
      //缓存的文本积木监听
      var textAddedList = []
      if (!this.mediaGotten) {
        //检验数据库有没有返回-可能不需要判断数据库有没有返回
        return
      }

      list.forEach((textTemp) => {
        let findMedia = this.Media.find(
          (item) => item && item.mediaFileUrl === textTemp.mediaFileUrl
        )
        // 如果从数据库中存取中没有的文本信息，则进行上传
        if (!findMedia) {
          textAddedList[textAddedList.length] = textTemp
        }
      })

      // 文本添加到数据库
      this.reduceArr(textAddedList) //去重
      // if (textAddedList.length > 0) {
      // }
    },
    //缓存的摄像头积木监听
    camTempList(camTempList) {
      var camAddedList = []
      // 摄像头提交到数据库
      this.reduceMediaArr(camAddedList) //去重
    },
  },
  mounted() {},

  methods: {
    //媒体的积木去重
    reduceMediaArr(List) {
      let obj = {}
      let newList = List.reduce((prev, cur) => {
        obj[cur.mediaFileUrl] && obj[cur.mediaFileName]
          ? ''
          : (obj[cur.mediaFileUrl] = true && prev.push(cur))
        return prev
      }, [])
      return newList
    },
    /**
  *
  *创建媒体积木功能
  上传图片的时候 创建积木列表
  */
    createBlocksByList(vList, camTempList, audioTempList, textTempList) {
      //去重
      vList = this.reduceArr(vList) //图片列表
      camTempList = this.reduceMediaArr(camTempList) //媒体积木先不去重
      audioTempList = this.reduceArr(audioTempList)
      textTempList = this.reduceArr(textTempList)
      var xmlList = [],
        audioXmlList = [],
        picXmlList = [],
        camXmlList = [],
        textXmlList = [],
        // 按钮
        buttonblock_1 =
          '<xml>' +
          //音频
          ' <label text="音频" web-class="block-text block-text1"></label>' +
          '<button text="+" callbackKey="myFirstButtonPressed3" web-class="block-btn-1"></button>' +
          ' <label text="" web-class="myLabelStyle" ></label>' +
          '</xml>',
        audioBlock =
          '<xml>' +
          //音频功能
          '<block type="play_audio"><value name="NAME"><shadow type="gta_ai_media_item"></shadow></value> </block>' +
          '<block type="pause_audio"> </block>' +
          '<block type="volume_add_audio"> </block>' +
          '<block type="volume_set_audio"> </block>' +
          '</xml>',
        buttonblock_2 =
          '<xml>' +
          //图片
          ' <label text="图片" web-class="block-text block-text2"></label>' +
          '<button text="+" callbackKey="myFirstButtonPressed" web-class="block-btn-2"></button>' +
          ' <label text="" web-class="myLabelStyle2" ></label>' +
          '</xml>',
        buttonblock_3 =
          '<xml>' +
          //摄像头
          '<label text="摄像头"   web-class="block-text block-text3"  ></label>' +
          '<button text="+" callbackKey="myFirstButtonPressed2" web-class="block-btn-3" ></button>' +
          ' <label text="" web-class="myLabelStyle3"></label>' +
          '</xml>',
        buttonblock_4 =
          '<xml>' +
          //文本
          ' <label text="文本" web-class="block-text block-text4"></label>' +
          '<button text="+" callbackKey="myFirstButtonPressed4" web-class="block-btn-4"></button>' +
          ' <label text="" web-class="myLabelStyle4" ></label>' +
          '</xml>'

      //动态媒体类型的音频、图片、摄像头标签的动态位置
      this.setFlyoutLabelPosition()

      // 图片积木
      for (let i = 0; i < vList.length; i++) {
        //截取获取图片的名称
        var imageName = vList[i].mediaFileName || '图片'
        var index_1 = imageName.indexOf('.')
        if (index_1 != -1) {
          imageName = imageName.slice(0, index_1)
        }
        if (!imageName) {
          imageName = '图片'
        }
        var enstr = this.$util.urlToStr.encrypt(vList[i].mediaFileUrl) //加密
        var typestrurl = 'MEDIAPIC' + enstr + 'mediaFileName=' + imageName
        // 传入url,新建不同的积木块
        var blockCreateTxt =
            "Blockly.Blocks['" +
            typestrurl +
            "'] = {" +
            'init: function () {' +
            'this.appendDummyInput()' +
            '.appendField(new Blockly.FieldImage("' +
            vList[i].mediaFileUrl +
            // vList[i] +
            '", 30, 30, "*"))' +
            '.appendField("' +
            imageName +
            '");' +
            'this.setOutput(true, null);' +
            "this.setStyle('media_blocks');" +
            'this.setTooltip("");' +
            `this.setHelpUrl("${Blockly.Msg['PIC_BLOCKS_HELPURL']}");` +
            ' }' +
            ',' +
            'customContextMenu:function(options) {' +
            'var option= {' +
            'enabled:true,' +
            'text:"删除",' +
            'callback:function() {' +
            "deleteMedia('" +
            vList[i].mediaFileUrl +
            "','" +
            imageName +
            "');" +
            '}.bind(this)' +
            '};' +
            'var option2= {' +
            'enabled:true,' +
            'text:"重命名",' +
            'callback:function() {' +
            "renamePic(this.getFieldValue(),'" +
            imageName +
            "');" +
            '}.bind(this)' +
            '};' +
            'options.push(option);' +
            'options.push(option2);' +
            '}' +
            '};' +
            " Blockly.Python['" +
            typestrurl +
            "'] = function(block) {return ['" +
            '"' +
            vList[i].mediaFileUrl +
            '"' +
            "',Blockly.Python.ORDER_FUNCTION_CALL ];};",
          blockCreate = new Function(
            'Blockly',
            'deleteMedia',
            'renamePic',
            blockCreateTxt
          )

        // 如果已经存在就不用再创建
        if (!Blockly.Blocks[typestrurl]) {
          blockCreate.call(this, Blockly, this.deleteMedia, this.renamePic)
        }

        var blockText =
          '<xml>' + '<block type="' + typestrurl + '">' + '</block>' + '</xml>'
        var block = Blockly.Xml.textToDom(blockText).firstChild
        picXmlList.push(block)
      }

      // 摄像头积木
      for (let i = 0; i < camTempList.length; i++) {
        //截取获取图片的名称
        var mediaFileName = camTempList[i].mediaFileName
        var mediaFileUrl = camTempList[i].mediaFileUrl
        // 创建积木代码
        if (!mediaFileName) {
          mediaFileName = '摄像头'
        }
        var encryptCamera =
          'MEDIACAM' +
          this.$util.urlToStr.encrypt(mediaFileUrl) +
          'mediaFileName=' +
          mediaFileName

        var blockCreateTxt2 =
            "Blockly.Blocks['" +
            encryptCamera +
            "'] = {" +
            'init:function () {' +
            'this.appendDummyInput()' +
            '.appendField("' +
            mediaFileName +
            '");' +
            'this.setOutput(true, null);' +
            "this.setStyle('media_blocks');" +
            'this.setTooltip("");' +
            `this.setHelpUrl("${Blockly.Msg['PLAY_CAMERA_HELPURL']}");` +
            ' }' +
            ',' +
            'customContextMenu:function(options) {' +
            'var option= {' +
            'enabled:true,' +
            'text:"删除",' +
            'callback:function() {' +
            "deleteCameraMedia('" +
            mediaFileUrl +
            "','" +
            mediaFileName +
            "');" +
            '}.bind(this)' +
            '};' +
            'var option2= {' +
            'enabled:true,' +
            'text:"重命名",' +
            'callback:function() {' +
            "renameCam('" +
            mediaFileUrl +
            "','" +
            mediaFileName +
            "');" +
            '}.bind(this)' +
            '};' +
            'options.push(option);' +
            'options.push(option2);' +
            '}' +
            '};' +
            " Blockly.Python['" +
            encryptCamera +
            "'] = function(block) { return ['" +
            'url=' +
            '"' +
            mediaFileUrl +
            '"' +
            "',Blockly.Python.ORDER_FUNCTION_CALL];};",
          // "'] = function(block) { return ['\"'+block.getFieldValue()+'\"',Blockly.Python.ORDER_FUNCTION_CALL];};",
          blockCreate2 = new Function(
            'Blockly',
            'deleteCameraMedia',
            'renameCam',
            blockCreateTxt2
          )

        // 如果已经存在就不用再创建
        if (!Blockly.Blocks[encryptCamera]) {
          blockCreate2.call(
            this,
            Blockly,
            this.deleteCameraMedia,
            this.renameCam
          )
        }
        var blockText2 =
          '<xml>' +
          '<block type="' +
          encryptCamera +
          '">' +
          '</block>' +
          '</xml>'
        var block2 = Blockly.Xml.textToDom(blockText2).firstChild
        // xmlList.unshift(block);
        camXmlList.push(block2)
      }

      // 音频积木
      for (let i = 0; i < audioTempList.length; i++) {
        //截取获取图片的名称
        let mediaFileName = audioTempList[i].mediaFileName,
          mediaFileUrl = audioTempList[i].mediaFileUrl
        // 创建积木代码
        if (!mediaFileName) {
          mediaFileName = '音频'
        }
        let encryptCamera =
          'MEDIAAUDIO' +
          this.$util.urlToStr.encrypt(mediaFileUrl) +
          'mediaFileName=' +
          mediaFileName

        let blockCreateTxt2 =
            "Blockly.Blocks['" +
            encryptCamera +
            "'] = {" +
            'init:function () {' +
            'this.appendDummyInput()' +
            '.appendField("' +
            mediaFileName +
            '");' +
            'this.setOutput(true, null);' +
            "this.setStyle('media_blocks');" +
            'this.setTooltip("");' +
            `this.setHelpUrl("${Blockly.Msg['UPLOAD_AUDIO_HELPURL']}");` +
            ' }' +
            ',' +
            'customContextMenu:function(options) {' +
            'var option= {' +
            'enabled:true,' +
            'text:"删除",' +
            'callback:function() {' +
            "deleteAudioMedia('" +
            mediaFileUrl +
            "','" +
            mediaFileName +
            "');" +
            '}.bind(this)' +
            '};' +
            'var option2= {' +
            'enabled:true,' +
            'text:"重命名",' +
            'callback:function() {' +
            "renameAudio('" +
            mediaFileUrl +
            "','" +
            mediaFileName +
            "');" +
            '}.bind(this)' +
            '};' +
            'options.push(option);' +
            'options.push(option2);' +
            '}' +
            '};' +
            " Blockly.Python['" +
            encryptCamera +
            "'] = function(block) { return ['" +
            // "url=" +
            '"' +
            mediaFileUrl +
            '"' +
            "',Blockly.Python.ORDER_FUNCTION_CALL];};",
          blockCreate2 = new Function(
            'Blockly',
            'deleteAudioMedia',
            'renameAudio',
            blockCreateTxt2
          )

        // 如果已经存在就不用再创建
        if (!Blockly.Blocks[encryptCamera]) {
          blockCreate2.call(
            this,
            Blockly,
            this.deleteAudioMedia,
            this.renameAudio
          )
        }
        let blockText2 =
          '<xml>' +
          '<block type="' +
          encryptCamera +
          '">' +
          '</block>' +
          '</xml>'
        let block2 = Blockly.Xml.textToDom(blockText2).firstChild
        // xmlList.unshift(block);
        audioXmlList.push(block2)
      }

      // 文本积木
      for (let i = 0; i < textTempList.length; i++) {
        //截取获取图片的名称
        let textName = textTempList[i].mediaFileName || '文本'
        let mediaFileUrl = textTempList[i].mediaFileUrl
        let index_1 = textName.indexOf('.')
        if (index_1 != -1) {
          textName = textName.slice(0, index_1)
        }
        let enstr = this.$util.urlToStr.encrypt(textTempList[i].mediaFileUrl) //加密
        let typestrurl = 'MEDIATEXT' + enstr + 'mediaFileName=' + textName
        // 传入url,新建不同的积木块
        let blockCreateTxt =
            "Blockly.Blocks['" +
            typestrurl +
            "'] = {" +
            'init: function () {' +
            'this.appendDummyInput()' +
            '.appendField("' +
            textName +
            '");' +
            'this.setOutput(true, null);' +
            "this.setStyle('media_blocks');" +
            'this.setTooltip("");' +
            `this.setHelpUrl("${Blockly.Msg['PIC_BLOCKS_HELPURL']}");` +
            ' }' +
            ',' +
            'customContextMenu:function(options) {' +
            'var option= {' +
            'enabled:true,' +
            'text:"删除",' +
            'callback:function() {' +
            "deleteTextMedia('" +
            mediaFileUrl +
            "','" +
            textName +
            "');" +
            '}.bind(this)' +
            '};' +
            'var option2= {' +
            'enabled:true,' +
            'text:"重命名",' +
            'callback:function() {' +
            "renameText('" +
            mediaFileUrl +
            "','" +
            textName +
            "');" +
            '}.bind(this)' +
            '};' +
            'options.push(option);' +
            'options.push(option2);' +
            '}' +
            '};' +
            " Blockly.Python['" +
            typestrurl +
            "'] = function(block) {return ['" +
            '"' +
            textTempList[i].mediaFileUrl +
            '"' +
            "',Blockly.Python.ORDER_FUNCTION_CALL ];};",
          blockCreate = new Function(
            'Blockly',
            'deleteTextMedia',
            'renameText',
            blockCreateTxt
          )

        // 如果已经存在就不用再创建
        if (!Blockly.Blocks[typestrurl]) {
          blockCreate.call(this, Blockly, this.deleteTextMedia, this.renameText)
        }

        let blockText =
          '<xml>' + '<block type="' + typestrurl + '">' + '</block>' + '</xml>'
        let block = Blockly.Xml.textToDom(blockText).firstChild
        textXmlList.push(block)
      }

      //分类依序放置音频、图片、媒体的积木
      xmlList = [
        ...Blockly.Xml.textToDom(buttonblock_1).childNodes,
        ...audioXmlList,
        ...Blockly.Xml.textToDom(audioBlock).childNodes,
        ...Blockly.Xml.textToDom(buttonblock_2).childNodes,
        ...picXmlList,
        ...Blockly.Xml.textToDom(buttonblock_3).childNodes,
        ...camXmlList,
        ...Blockly.Xml.textToDom(buttonblock_4).childNodes,
        ...textXmlList,
      ]
      return xmlList
    },

    //从工作台创建媒体类积木
    createMediaBlocksByWorkspaceXML(oldWorkspaceXmlTxt, typestrurl, renameVal) {
      let arr = oldWorkspaceXmlTxt
          ? oldWorkspaceXmlTxt.split('<block type=')
          : [],
        i
      let photoBaseUrl = this.photoBaseUrl

      for (i = 0; i < arr.length; i++) {
        // 图片缓存
        if (arr[i].substring(0, 9) == '"MEDIAPIC') {
          let picarr, enstr, urlstr, ImgIndex, nameStr, mediaFileName
          picarr = arr[i].split('"')
          enstr = picarr[1].substring(8, picarr[1].length)
          ImgIndex = enstr.indexOf('mediaFileName=')
          let subEnstr = enstr.slice(0, ImgIndex)
          urlstr = this.$util.urlToStr.decrypt(subEnstr)
          urlstr = decodeURIComponent(urlstr)
          nameStr = enstr.slice(ImgIndex)
          mediaFileName = nameStr.replace('mediaFileName=', '')

          //如果typestrurl, renameVal有值，重命名处理
          if (typestrurl && renameVal && typestrurl == picarr[1]) {
            let reg_newName = /(?<=imageName=).*/
            picarr[1] = typestrurl.replace(reg_newName, renameVal)
            mediaFileName = renameVal
          }

          // 如果已经存在就不用再创建
          if (Blockly.Blocks[picarr[1]]) {
            continue
          }

          //转换url 的前缀domain
          urlstr = this.$util.exchangeMediaDomain(urlstr, photoBaseUrl)

          //工作区未存在Media列表的积木添加到媒体积木列表Media，并向请求接口对应增加一个积木数据
          setTimeout(() => {
            let urlstr_2 = urlstr.replace(photoBaseUrl, '')
            let mediaItem = this.Media.find(
              (item) =>
                item.mediaFileName == mediaFileName &&
                (item.mediaFileUrl === urlstr || item.mediaFileUrl === urlstr_2)
            )
            if (!mediaItem) {
              this.mediaUpload([
                {
                  mediaFileUrl: urlstr_2,
                  mediaFileName: mediaFileName,
                },
              ])
              //加载到缓存
              this.picTempList.push({
                mediaFileUrl: urlstr,
                mediaFileName: mediaFileName,
              })
            }
          }, 200)
          

          // 创建 blockly
          var blockCreateTxt =
              "Blockly.Blocks['" +
              picarr[1] +
              "'] = {" +
              'init: function () {' +
              'this.appendDummyInput()' +
              '.appendField(new Blockly.FieldImage("' +
              urlstr +
              '", 30, 30, "*"))' +
              '.appendField("' +
              mediaFileName +
              '");' +
              'this.setOutput(true, null);' +
              "this.setStyle('media_blocks');" +
              'this.setTooltip("");' +
              `this.setHelpUrl("${Blockly.Msg['PIC_BLOCKS_HELPURL']}");` +
              ' }' +
              ',' +
              'customContextMenu:function(options) {' +
              'var option= {' +
              'enabled:true,' +
              'text:"删除",' +
              'callback:function() {' +
              "deleteMedia('" +
              urlstr +
              "','" +
              mediaFileName +
              "');" +
              '}.bind(this)' +
              '};' +
              'var option2= {' + //重命名
              'enabled:true,' +
              'text:"重命名",' +
              'callback:function() {' +
              "renamePic(this.getFieldValue(),'" +
              mediaFileName +
              "');" +
              '}.bind(this)' +
              '};' +
              'options.push(option);' +
              'options.push(option2);' +
              '}' +
              '};' +
              " Blockly.Python['" +
              picarr[1] +
              "'] = function(block) {return ['" +
              '"' +
              urlstr.trim() +
              '"' +
              "',Blockly.Python.ORDER_FUNCTION_CALL ];};",
            // "'] = function(block) {return ['\"'+block.getFieldValue().trim()+'\"',Blockly.Python.ORDER_FUNCTION_CALL ];};",
            blockCreate = new Function(
              'Blockly',
              'deleteMedia',
              'renamePic',
              blockCreateTxt
            )
          blockCreate.call(this, Blockly, this.deleteMedia, this.renamePic)
          //加载到缓存
        }

        // 摄像头缓存
        if (arr[i].substring(0, 9) == '"MEDIACAM') {
          var camArr = arr[i].split('"')
          var enstr2 = camArr[1].substring(8, camArr[1].length)
          var camIndex = enstr2.indexOf('mediaFileName=')
          var nameStr2 = enstr2.slice(camIndex)
          var MediaFileName2 = nameStr2.replace('mediaFileName=', '')
          var enstr3 = enstr2.slice(0, camIndex)
          var mediaFileUrl = this.$util.urlToStr.decrypt(enstr3)
          // debugger;
          mediaFileUrl = decodeURIComponent(mediaFileUrl) //URI解码
          // 如果已经存在就不用再创建
          if (Blockly.Blocks[camArr[1]]) {
            continue
          }
          //工作区未存在Media列表的积木添加到媒体积木列表Media，并向请求接口对应增加一个积木数据
          setTimeout(() => {
            let mediaFileUrl_2 = mediaFileUrl.replace(photoBaseUrl, '')
            let mediaItem = this.Media.find(
              (item) =>
                item.mediaFileName == MediaFileName2 &&
                (item.mediaFileUrl === mediaFileUrl ||
                  item.mediaFileUrl === mediaFileUrl_2)
            )
            if (!mediaItem) {
              this.mediaUpload([
                {
                  mediaFileUrl: mediaFileUrl_2,
                  mediaFileName: MediaFileName2 || '摄像头',
                },
              ])
              //加载到缓存
              this.camTempList.push({
                mediaFileUrl: mediaFileUrl,
                mediaFileName: MediaFileName2 || '摄像头',
              })
            }
          }, 200)

          // 创建 blockly
          var blockCreateTxt2 =
              "Blockly.Blocks['" +
              camArr[1] +
              "'] = {" +
              'init:function () {' +
              'this.appendDummyInput()' +
              '.appendField("' +
              MediaFileName2 +
              '");' +
              'this.setOutput(true, null);' +
              "this.setStyle('media_blocks');" +
              'this.setTooltip("");' +
              `this.setHelpUrl("${Blockly.Msg['PLAY_CAMERA_HELPURL']}");` +
              ' }' +
              ',' +
              'customContextMenu:function(options) {' +
              'var option= {' +
              'enabled:true,' +
              'text:"删除",' +
              'callback:function() {' +
              "deleteCameraMedia('" +
              mediaFileUrl +
              "','" +
              MediaFileName2 +
              "');" +
              '}.bind(this)' +
              '};' +
              'var option2= {' +
              'enabled:true,' +
              'text:"重命名",' +
              'callback:function() {' +
              "renameCam('" +
              mediaFileUrl +
              "','" +
              MediaFileName2 +
              "');" +
              '}.bind(this)' +
              '};' +
              'options.push(option);' +
              'options.push(option2);' +
              '}' +
              '};' +
              " Blockly.Python['" +
              camArr[1] +
              "'] = function(block) { return ['" +
              // '"GTAMEDIA=[' +
              'url=' +
              '"' +
              mediaFileUrl +
              '"' +
              // ']=GTAMEDIA"' +
              "',Blockly.Python.ORDER_FUNCTION_CALL];};",
            // "'] = function(block) { return ['\"'+block.getFieldValue()+'\"',Blockly.Python.ORDER_FUNCTION_CALL];};",
            blockCreate2 = new Function(
              'Blockly',
              'deleteCameraMedia',
              'renameCam',
              blockCreateTxt2
            )

          // 将上述代码放入 Blockly 当中
          blockCreate2.call(
            this,
            Blockly,
            this.deleteCameraMedia,
            this.renameCam
          )
        }

        // 音频缓存
        if (arr[i].substring(0, 11) == '"MEDIAAUDIO') {
          let camArr = arr[i].split('"')
          let enstr2 = camArr[1].substring(10, camArr[1].length)
          let camIndex = enstr2.indexOf('mediaFileName')
          let nameStr2 = enstr2.slice(camIndex)
          let MediaFileName2 = nameStr2.replace('mediaFileName=', '')
          let enstr3 = enstr2.slice(0, camIndex)
          let mediaFileUrl = this.$util.urlToStr.decrypt(enstr3)
          mediaFileUrl = decodeURIComponent(mediaFileUrl) //URI解码
          // 如果已经存在就不用再创建
          if (Blockly.Blocks[camArr[1]]) {
            continue
          }

          //工作区未存在Media列表的积木添加到媒体积木列表Media，并向请求接口对应增加一个积木数据
          setTimeout(() => {
            let mediaFileUrl_2 = mediaFileUrl.replace(photoBaseUrl, '')
            let mediaItem = this.Media.find(
              (item) =>
                item.mediaFileName == MediaFileName2 &&
                (item.mediaFileUrl === mediaFileUrl ||
                  item.mediaFileUrl === mediaFileUrl_2)
            )
            if (!mediaItem) {
              this.mediaUpload([
                {
                  mediaFileUrl: mediaFileUrl_2,
                  mediaFileName: MediaFileName2 || '音频',
                },
              ])
              //加载到缓存
              this.audioTempList.push({
                mediaFileUrl: mediaFileUrl,
                mediaFileName: MediaFileName2 || '音频',
              })
            }
          }, 1000)

          // 创建 blockly
          let blockCreateTxt2 =
              "Blockly.Blocks['" +
              camArr[1] +
              "'] = {" +
              'init:function () {' +
              'this.appendDummyInput()' +
              '.appendField("' +
              MediaFileName2 +
              '");' +
              'this.setOutput(true, null);' +
              "this.setStyle('media_blocks');" +
              'this.setTooltip("");' +
              `this.setHelpUrl("${Blockly.Msg['UPLOAD_AUDIO_HELPURL']}");` +
              ' }' +
              ',' +
              'customContextMenu:function(options) {' +
              'var option= {' +
              'enabled:true,' +
              'text:"删除",' +
              'callback:function() {' +
              "deleteAudioMedia('" +
              mediaFileUrl +
              "','" +
              MediaFileName2 +
              "');" +
              '}.bind(this)' +
              '};' +
              'var option2= {' +
              'enabled:true,' +
              'text:"重命名",' +
              'callback:function() {' +
              "renameAudio('" +
              mediaFileUrl +
              "','" +
              MediaFileName2 +
              "');" +
              '}.bind(this)' +
              '};' +
              'options.push(option);' +
              'options.push(option2);' +
              '}' +
              '};' +
              " Blockly.Python['" +
              camArr[1] +
              "'] = function(block) { return ['" +
              // '"GTAMEDIA=[' +
              // "url=" +
              '"' +
              mediaFileUrl +
              '"' +
              // ']=GTAMEDIA"' +
              "',Blockly.Python.ORDER_FUNCTION_CALL];};",
            // "'] = function(block) { return ['\"'+block.getFieldValue()+'\"',Blockly.Python.ORDER_FUNCTION_CALL];};",
            blockCreate2 = new Function(
              'Blockly',
              'deleteAudioMedia',
              'renameAudio',
              blockCreateTxt2
            )

          // 将上述代码放入 Blockly 当中
          blockCreate2.call(
            this,
            Blockly,
            this.deleteAudioMedia,
            this.renameAudio
          )
        }
        // 文本缓存
        if (arr[i].substring(0, 10).search('MEDIATEXT') != -1) {
          let textArr = arr[i].split('"')
          let enstr2 = textArr[1].substring(9, textArr[1].length)
          let textIndex = enstr2.indexOf('mediaFileName')
          let nameStr2 = enstr2.slice(textIndex)
          let MediaFileName2 = nameStr2.replace('mediaFileName=', '')
          let enstr3 = enstr2.slice(0, textIndex)
          let mediaFileUrl = this.$util.urlToStr.decrypt(enstr3)
          mediaFileUrl = decodeURIComponent(mediaFileUrl) //URI解码
          // 如果已经存在就不用再创建
          if (Blockly.Blocks[textArr[1]]) {
            continue
          }

          //工作区未存在Media列表的积木添加到媒体积木列表Media，并向请求接口对应增加一个积木数据
          setTimeout(() => {
            let mediaFileUrl_2 = mediaFileUrl.replace(photoBaseUrl, '')
            let mediaItem = this.Media.find(
              (item) =>
                item.mediaFileName == MediaFileName2 &&
                (item.mediaFileUrl === mediaFileUrl ||
                  item.mediaFileUrl === mediaFileUrl_2)
            )
            if (!mediaItem) {
              this.mediaUpload([
                {
                  mediaFileUrl: mediaFileUrl_2,
                  mediaFileName: MediaFileName2 || '文本',
                },
              ])
              //加载到缓存
              this.textTempList.push({
                mediaFileUrl: mediaFileUrl,
                mediaFileName: MediaFileName2 || '文本',
              })
            }
          }, 1000)

          // 创建 blockly
          let blockCreateTxt2 =
              "Blockly.Blocks['" +
              textArr[1] +
              "'] = {" +
              'init:function () {' +
              'this.appendDummyInput()' +
              '.appendField("' +
              MediaFileName2 +
              '");' +
              'this.setOutput(true, null);' +
              "this.setStyle('media_blocks');" +
              'this.setTooltip("");' +
              `this.setHelpUrl("${Blockly.Msg['UPLOAD_AUDIO_HELPURL']}");` +
              ' }' +
              ',' +
              'customContextMenu:function(options) {' +
              'var option= {' +
              'enabled:true,' +
              'text:"删除",' +
              'callback:function() {' +
              "deleteTextMedia('" +
              mediaFileUrl +
              "','" +
              MediaFileName2 +
              "');" +
              '}.bind(this)' +
              '};' +
              'var option2= {' +
              'enabled:true,' +
              'text:"重命名",' +
              'callback:function() {' +
              "renameText('" +
              mediaFileUrl +
              "','" +
              MediaFileName2 +
              "');" +
              '}.bind(this)' +
              '};' +
              'options.push(option);' +
              'options.push(option2);' +
              '}' +
              '};' +
              " Blockly.Python['" +
              textArr[1] +
              "'] = function(block) { return ['" +
              '"' +
              mediaFileUrl +
              '"' +
              "',Blockly.Python.ORDER_FUNCTION_CALL];};",
            blockCreate2 = new Function(
              'Blockly',
              'deleteTextMedia',
              'renameText',
              blockCreateTxt2
            )

          // 将上述代码放入 Blockly 当中
          blockCreate2.call(
            this,
            Blockly,
            this.deleteTextMedia,
            this.renameText
          )
        }
      }
    },

    reduceArr(List) {
      let obj = {}
      let newList = List.reduce((prev, cur) => {
        obj[cur.mediaFileUrl]
          ? ''
          : (obj[cur.mediaFileUrl] = true && prev.push(cur))
        return prev
      }, [])
      return newList
    },

    //动态媒体类型的音频、图片、摄像头标签的动态位置
    setFlyoutLabelPosition() {
      setTimeout(() => {
        //媒体标签的样式设置，需异步
        let flyoutWidth = sessionStorage.flyoutWidth,
          trans_match = /(?<=translate\().*(?=\))/,
          scrollWidth = flyoutWidth - 40,
          myLabelStyle1 = document.querySelector('.block-text1'),
          myLabelStyle2 = document.querySelector('.block-text2'),
          myLabelStyle3 = document.querySelector('.block-text3'),
          myLabelStyle4 = document.querySelector('.block-text4'),
          myBtnStyle1 = document.querySelector('.block-btn-1'),
          myBtnStyle2 = document.querySelector('.block-btn-2'),
          myBtnStyle3 = document.querySelector('.block-btn-3'),
          myBtnStyle4 = document.querySelector('.block-btn-4'),
          transform_1 = myLabelStyle1.getAttribute('transform'),
          y_1 = transform_1.match(trans_match)[0].split(',')[1],
          transform_2 = myLabelStyle2.getAttribute('transform'),
          y_2 = transform_2.match(trans_match)[0].split(',')[1],
          transform_3 = myLabelStyle3.getAttribute('transform'),
          y_3 = transform_3.match(trans_match)[0].split(',')[1],
          transform_4 = myLabelStyle4.getAttribute('transform'),
          y_4 = transform_4.match(trans_match)[0].split(',')[1],
          y_1_1 = eval(y_1) + 35,
          y_2_1 = eval(y_2) + 35,
          y_3_1 = eval(y_3) + 35,
          y_4_1 = eval(y_4) + 35
        myLabelStyle1.setAttribute(
          'transform',
          'translate(' + 5 + ',' + y_1 + ')'
        )
        myLabelStyle2.setAttribute(
          'transform',
          'translate(' + 5 + ',' + y_2 + ')'
        )
        myLabelStyle3.setAttribute(
          'transform',
          'translate(' + 5 + ',' + y_3 + ')'
        )
        myLabelStyle4.setAttribute(
          'transform',
          'translate(' + 5 + ',' + y_4 + ')'
        )
        myBtnStyle1.setAttribute(
          'transform',
          'translate(' + scrollWidth + ',' + y_1_1 + ')'
        )
        myBtnStyle2.setAttribute(
          'transform',
          'translate(' + scrollWidth + ',' + y_2_1 + ')'
        )
        myBtnStyle3.setAttribute(
          'transform',
          'translate(' + scrollWidth + ',' + y_3_1 + ')'
        )
        myBtnStyle4.setAttribute(
          'transform',
          'translate(' + scrollWidth + ',' + y_4_1 + ')'
        )
      }, 50)
    },

    /**
     *
     *
     * 图片、音频、文本上传按钮功能区
     *
     *  */
    // 图片变量创建按钮
    btnCreatePictureBlock() {
      //上传图片
      var inputNode = document.createElement('input'),
        self = this,
        clickTarget = this.elMedia,
        reg_name = /[`~!@#$^&*()=|{}':;',\\[\].<>/?~！@#￥……&*（）——|{}【】'；：""'。，、？\s0e]/g,
        nodeList = document.querySelectorAll(
          '.blocklyTreeRow > .blocklyTreeLabel'
        )

      // 获取元素，再次定位媒体位置，做二次点击处理
      if (!clickTarget) {
        for (let i = 0, len = nodeList.length; i < len; i++) {
          let node = nodeList[i]
          if (node.textContent.indexOf('媒体') > -1) {
            this.elMedia = clickTarget = node.parentNode
          }
        }
      }
      // 文件上传按钮配置
      inputNode.setAttribute('type', 'file')
      inputNode.setAttribute('multiple', 'true')
      inputNode.setAttribute('accept', 'image/*') // 限制.rar 和.zip压缩文件格式上传
      //文件上传到-资源平台服务器
      self.inputUploadFile(inputNode, clickTarget, self.picTempList, 'image')
      // 点击上传按钮
      inputNode.click()
    },
    // 音频变量创建按钮
    btnCreateAudioBlock() {
      //上传音频
      var inputNode = document.createElement('input')
      let self = this,
        clickTarget = this.elMedia,
        reg_name = /[`~!@#$^&*()=|{}':;',\\[\]<>/?~！@#￥……&*（）——|{}【】'；：""'。，、？\s0e]/g,
        nodeList = document.querySelectorAll(
          '.blocklyTreeRow > .blocklyTreeLabel'
        )

      // if (!this.projectId || this.projectId === this.Placeholder.ProjectId) {
      //   this.$message({
      //     message: "项目案例保存后再修改~",
      //     type: "warning",
      //     duration: 2000
      //   });
      //   return;
      // }

      // 获取元素，再次定位媒体位置，做二次点击处理
      if (!clickTarget) {
        for (let i = 0, len = nodeList.length; i < len; i++) {
          let node = nodeList[i]
          if (node.textContent.indexOf('媒体') > -1) {
            this.elMedia = clickTarget = node.parentNode
          }
        }
      }

      // 文件上传按钮配置
      inputNode.setAttribute('type', 'file')
      inputNode.setAttribute('multiple', 'true')
      inputNode.setAttribute('accept', 'audio/*')
      //文件上传到-资源平台服务器
      self.inputUploadFile(inputNode, clickTarget, self.audioTempList, 'audio')

      // 点击上传按钮
      inputNode.click()
    },
    // 摄像头变量创建按钮
    btnCreateCameraBlock() {
      //打开摄像头弹框
      this.popupActive = 'camera'
    },

    // 文本变量创建按钮
    btnCreateTextBlock() {
      //上传文本
      var inputNode = document.createElement('input'),
        self = this,
        clickTarget = this.elMedia,
        reg_name = /[`~!@#$^&*()=|{}':;',\\[\].<>/?~！@#￥……&*（）——|{}【】'；：""'。，、？\s0e]/g,
        nodeList = document.querySelectorAll(
          '.blocklyTreeRow > .blocklyTreeLabel'
        )

      // 获取元素，再次定位媒体位置，做二次点击处理
      if (!clickTarget) {
        for (let i = 0, len = nodeList.length; i < len; i++) {
          let node = nodeList[i]
          if (node.textContent.indexOf('媒体') > -1) {
            this.elMedia = clickTarget = node.parentNode
          }
        }
      }
      // 文件上传按钮配置
      inputNode.setAttribute('type', 'file')
      inputNode.setAttribute('multiple', 'true')
      inputNode.setAttribute('accept', '.txt') // 限制.rar 和.zip压缩文件格式上传

      //文件上传到-资源平台服务器
      self.inputUploadFile(inputNode, clickTarget, self.textTempList, 'txt')

      // 点击上传按钮
      inputNode.click()
    },
    //文件上传到-资源平台服务器
    inputUploadFile(inputNode, clickTarget, tempList, fileName) {
      let self = this,
        reg_name = /[`~!@#$^&*()=|{}':;',\\[\].<>/?~！@#￥……&*（）——|{}【】'；：""'。，、？\se]/g
      inputNode.onchange = function uploadImg(evt) {
        // 获取 file
        let fileList = evt.target.files,
          list = Array.from(fileList),
          formatPass,
          formdata = new FormData()

        list.forEach((file) => {
          formdata.append('file', file)
        })
        // 实例化
        // var fileName = file.name
        //过滤特殊字符
        // fileName = fileName.replace(reg_name, '')
        //截取名称长度
        // fileName = fileName.slice(0, 10)
        let pic_match = /.jpeg|.png|.jpg|.svg/i,
          audio_match = /.WMA|.mp3|.wav|.wma|.ape|.flac|.ogg|.aac|.m4a/i,
          text_match = /.txt/i
        if (list.length > 20) {
          return self.$message({
            message: '单次上传不可超过20个文件哦！',
            type: 'error',
            duration: 2000,
          })
        }

        if (fileName === 'txt') {
          formatPass = self.$util.filesFormatEveryCheck(list, text_match)
          if (!formatPass) {
            self.$message({
              message: '上传失败，请上传txt文件！',
              type: 'error',
              duration: 2000,
            })
            return
          }
        } else if (fileName === 'image') {
          formatPass = self.$util.filesFormatEveryCheck(list, pic_match)
          if (!formatPass) {
            self.$message({
              message: '上传失败，请上传图片！',
              type: 'error',
              duration: 2000,
            })
            return
          }
        } else if (fileName === 'audio') {
          formatPass = self.$util.filesFormatEveryCheck(list, audio_match)
          if (!formatPass) {
            self.$message({
              message: '上传失败，请上传音频！',
              type: 'error',
              duration: 2000,
            })
            return
          }
        }

        const loading = self.$loading({
          lock: true,
          text: '上传中请稍等...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        })
        setTimeout(() => {
          loading.close() // 超过60秒时关闭loading效果
        }, 1000 * 60)

        COMMON.UploadMultipleFile(formdata)
          .then(async (result) => {
            if (result && result.returnCode == 200 && result.data) {
              // 单击媒体分类位置
              clickTarget.click()
              let arr = []
              if (fileName === 'image') {
                let imgList = result.data
                let params = {
                  imgUrls: [],
                }
                if (imgList.length === 0) {
                  return loading.close()
                }
                params.imgUrls = imgList.map((item) => {
                  return {
                    fileName: item.fileName, // 文件名称
                    // fileUrl: `${self.photoBaseUrl}${item.url}`, // 文件url
                    fileUrl: `${self.fileBaseUrl}${item.url}`, // 文件url
                  }
                })
                COMMON.verifyImgs(params).then((res) => {
                  if (res.isSuccess) {
                    if (
                      res.data &&
                      res.data.correct &&
                      res.data.correct.length
                    ) {
                      res.data.correct.forEach((i) => {
                        imgList.forEach((j) => {
                          if (i.fileUrl.indexOf(`${j.url}`) !== -1) {
                            //过滤特殊字符
                            let mediaFileName = j.fileName.replace(reg_name, '')
                            //截取名称长度
                            mediaFileName = mediaFileName.slice(0, 10)
                            let mediaFileUrl = j.url
                            // let mediaFileUrl = self.photoBaseUrl + j.url;
                            arr.push({ mediaFileName, mediaFileUrl })
                          }
                        })
                      })
                      // 更新数据库
                      self.mediaUpload(arr, clickTarget)
                    }
                    if (res.data && res.data.error_info.length) {
                      res.data.error_info.forEach((i, idx) => {
                        setTimeout(() => {
                          self.$message.error(
                            `上传失败，图片名称为“${i.fileName}”，该文件格式被后期修改过，其真实格式不为jpg/jpeg！`
                          )
                        }, idx * 10)
                      })
                    }
                  } else {
                    self.$message.error('上传失败!')
                  }
                })
              } else {
                result.data.forEach((item) => {
                  //过滤特殊字符
                  let mediaFileName = item.fileName.replace(reg_name, '')
                  //截取名称长度
                  mediaFileName = mediaFileName.slice(0, 10)
                  let mediaFileUrl = item.url
                  // let mediaFileUrl = self.photoBaseUrl + item.url;
                  arr.push({ mediaFileName, mediaFileUrl })
                })
                // 更新数据库
                await self.mediaUpload(arr, clickTarget)
              }

              inputNode = null // 释放 input
              // 单击媒体分类位置，图片显示
              // clickTarget.click()
              loading.close()
            } else {
              loading.close()
            }
          })
          .catch((err) => {
            loading.close()
          })
      }
    },

    // 提交媒体图片上传接口
    async mediaUpload(mediaList, clickTarget) {
      let { trainingId, accountInfo, projectId } = this,
        result,
        data = {}
      data.mediaList = mediaList
      //新增媒体积木存放在后台
      if (trainingId) {
        //实训中心的调用
        data.trainingId = trainingId
        data.userId = accountInfo.userId
        result = await BLOCK.insertMedia(data)
      } else if (projectId) {
        //ai-editor的调用
        data.projectId = projectId
        result = await AI_EDITOR.insertMedia(data)
      } else {
        return
      }

      if (result.isSuccess) {
        await this.getMedia() //重新获取媒体积木;
        if (clickTarget) {
          clickTarget.click()
        }
        this.mediaGotten = 1 //代表上传了数据
      } else {
        this.$message.error('媒体变量上传失败!')
      }
    },
    async getMedia(pageIndex) {
      return await this.$parent.getMedia()

      // let res = await this.$emit('getMedia', pageIndex)
    },

    /**
     *
     *
     * 删除积木功能操作
     *  */
    //删除图片
    deleteMedia(fileUrl, mediaFileName) {
      //加密，同步于创建图片变量中的 url 转化为 base64 的操作
      var enstr = this.$util.urlToStr.encrypt(fileUrl),
        typestrurl = 'MEDIAPIC' + enstr + 'mediaFileName=' + mediaFileName,
        typeBlocks = this.workspace.getBlocksByType(typestrurl),
        typeBlocksLen = typeBlocks.length,
        msgConfirm = `要删除对该媒体变量的 ${typeBlocksLen} 个引用吗？`
      // 检测该图片变量是否还在使用
      if (typeBlocksLen) {
        // 弹窗是否要删除图片变量
        this.$confirm(msgConfirm).then((action) => {
          if (action === 'confirm') {
            this.mediaDeleteByKey(fileUrl, mediaFileName).then((/*result*/) => {
              // 删除 workspace 中的积木
              typeBlocks.forEach((block) => {
                block.dispose(false, true)
              })
            })
          } else {
            return
          }
        })
      } else {
        this.mediaDeleteByKey(fileUrl, mediaFileName).then((/*result*/) => {
          // 删除 workspace 中的积木
          typeBlocks.forEach((block) => {
            block.dispose(false, true)
          })
          // 更新服务器 Xml 文件
          // this.xmlDataUpdate();
        })
      }
    },
    // 删除摄像头积木
    deleteCameraMedia(fileUrl, mediaFileName) {
      //加密，同步于创建图片变量中的 url 转化为 base64 的操作
      var enstr = this.$util.urlToStr.encrypt(fileUrl),
        typestrurl = 'MEDIACAM' + enstr + 'mediaFileName' + mediaFileName,
        typeBlocks = this.workspace.getBlocksByType(typestrurl),
        typeBlocksLen = typeBlocks.length,
        msgConfirm = `要删除对该媒体变量的 ${typeBlocksLen} 个引用吗？`
      // 检测该图片变量是否还在使用
      if (typeBlocksLen) {
        this.$confirm(msgConfirm).then((action) => {
          if (action === 'confirm') {
            this.mediaDeleteByKey(fileUrl, mediaFileName).then((/*result*/) => {
              // 删除 workspace 中的积木
              typeBlocks.forEach((block) => {
                block.dispose(false, true)
              })

              // 更新服务器 Xml 文件
              this.xmlDataUpdate()
            })
          } else {
            return
          }
        })
      } else {
        this.mediaDeleteByKey(fileUrl, mediaFileName).then((/*result*/) => {
          // 删除 workspace 中的积木
          typeBlocks.forEach((block) => {
            block.dispose(false, true)
          })

          // 更新服务器 Xml 文件
          this.xmlDataUpdate()
        })
      }
    },
    // 删除音频积木
    deleteAudioMedia(fileUrl, mediaFileName) {
      //加密，同步于创建图片变量中的 url 转化为 base64 的操作
      var enstr = this.$util.urlToStr.encrypt(fileUrl),
        typestrurl = 'MEDIAAUDIO' + enstr + 'mediaFileName' + mediaFileName,
        typeBlocks = this.workspace.getBlocksByType(typestrurl),
        typeBlocksLen = typeBlocks.length,
        msgConfirm = `要删除对该媒体变量的 ${typeBlocksLen} 个引用吗？`

      // 检测该变量是否还在使用
      if (typeBlocksLen) {
        // 弹窗是否要删除音频变量
        this.$confirm(msgConfirm).then((action) => {
          if (action === 'confirm') {
            this.mediaDeleteByKey(fileUrl, mediaFileName).then((/*result*/) => {
              // 删除 workspace 中的积木
              typeBlocks.forEach((block) => {
                block.dispose(false, true)
              })

              // 更新服务器 Xml 文件
              this.xmlDataUpdate()
            })
          } else {
            return
          }
        })
      } else {
        this.mediaDeleteByKey(fileUrl, mediaFileName).then((/*result*/) => {
          // 删除 workspace 中的积木
          typeBlocks.forEach((block) => {
            block.dispose(false, true)
          })

          // 更新服务器 Xml 文件
          // this.xmlDataUpdate();
        })
      }
    },
    // 删除
    deleteTextMedia(fileUrl, mediaFileName) {
      //加密，同步于创建图片变量中的 url 转化为 base64 的操作
      var enstr = this.$util.urlToStr.encrypt(fileUrl),
        typestrurl = 'MEDIATEXT' + enstr + 'mediaFileName' + mediaFileName,
        typeBlocks = this.workspace.getBlocksByType(typestrurl),
        typeBlocksLen = typeBlocks.length,
        msgConfirm = `要删除对该媒体变量的 ${typeBlocksLen} 个引用吗？`

      // 检测该变量是否还在使用
      if (typeBlocksLen) {
        // 弹窗是否要删除音频变量
        this.$confirm(msgConfirm).then((action) => {
          if (action === 'confirm') {
            this.mediaDeleteByKey(fileUrl, mediaFileName).then((/*result*/) => {
              // 删除 workspace 中的积木
              typeBlocks.forEach((block) => {
                block.dispose(false, true)
              })

              // 更新服务器 Xml 文件
              this.xmlDataUpdate()
            })
          } else {
            return
          }
        })
      } else {
        this.mediaDeleteByKey(fileUrl, mediaFileName).then((/*result*/) => {
          // 删除 workspace 中的积木
          typeBlocks.forEach((block) => {
            block.dispose(false, true)
          })
          // 更新服务器 Xml 文件
          // this.xmlDataUpdate();
        })
      }
    },
    // 删除服务器数据库中数据以及后续处理
    mediaDeleteByKey(fileUrl, mediaFileName) {
      let self = this,
        findMedia,
        clickTarget = this.elMedia,
        nodeList = document.querySelectorAll(
          '.blocklyTreeRow > .blocklyTreeLabel'
        ),
        photoBaseUrl = this.photoBaseUrl,
        fileUrl_2 = fileUrl.replace(photoBaseUrl, '')

      findMedia = this.Media.find(
        (item) =>
          item &&
          (item.mediaFileUrl === fileUrl || item.mediaFileUrl === fileUrl_2)
        // &&item.mediaFileName === mediaFileName
      )
      // 数据库内删除图片
      return new Promise((resolve, reject) => {
        // 获取元素，再次定位媒体位置，做二次点击处理
        if (!clickTarget) {
          for (let i = 0, len = nodeList.length; i < len; i++) {
            let node = nodeList[i]
            if (node.textContent.indexOf('媒体') > -1) {
              this.elMedia = clickTarget = node.parentNode
            }
          }
        }

        if (findMedia != -1) {
          // 删除图片缓存数据

          let picTempList = self.picTempList.reduce(
            (total, item, index, arr) => {
              if (
                item &&
                item.mediaFileUrl === fileUrl &&
                item.mediaFileName == mediaFileName
              ) {
                clickTarget.click()

                setTimeout(() => {
                  clickTarget.click()
                }, 200)
              } else {
                total.push(item)
              }
              // console.log("-----total",total)
              return total
            },
            []
          )
          this.$forceUpdate()
          this.picTempList = picTempList
          this.$set(this, 'picTempList', picTempList) //更新数组
          // console.log('self.picTempList2', this.picTempList)
          self.$forceUpdate() //强制更新
          // 删除摄像头缓存数据
          self.camTempList.forEach((item, index, arr) => {
            if (
              item &&
              new RegExp(item.mediaFileUrl).test(fileUrl) &&
              item.mediaFileName == mediaFileName
            ) {
              clickTarget.click()
              arr.splice(index, 1)
              clickTarget.click()
              resolve()
              return index
            }
          })

          // 删除音频缓存数据
          self.audioTempList.forEach((item, index, arr) => {
            if (
              item &&
              item.mediaFileUrl == fileUrl &&
              item.mediaFileName == mediaFileName
            ) {
              clickTarget.click()
              arr.splice(index, 1)
              clickTarget.click()
              resolve()
              return index
            }
          })
          // 删除文本缓存数据
          self.textTempList.forEach((item, index, arr) => {
            if (
              item &&
              item.mediaFileUrl == fileUrl &&
              item.mediaFileName == mediaFileName
            ) {
              clickTarget.click()
              arr.splice(index, 1)
              clickTarget.click()
              resolve()
              return index
            }
          })
        }

        let data = {
          mediaId: findMedia.mediaId,
          mediaFileName: findMedia.mediaFileName,
        }
        if (this.trainingId) {
          //实训中心编辑器的逻辑删除api
          BLOCK.deleteMedia(data).then((result) => {
            if (result.isSuccess) {
              resolve(result)
            } else {
              reject(result)
            }
          })
        } else {
          //AI-T编辑器的删除api
          AI_EDITOR.deleteMedia(data).then((result) => {
            if (result.isSuccess) {
              resolve(result)
            } else {
              reject(result)
            }
          })
        }
      })
    },

    /**
     *
     *
     * 积木重命名功能操作
     *  */
    //图片重命名
    renamePic(fileUrl, mediaFileName) {
      this.renamePicObj = { fileUrl, mediaFileName }
      this.renameCamObj = {}
      this.renameAudioObj = {}
      this.renameTextObj = {}
      this.popupActive = 'rename'
    },
    //摄像头重命名
    renameCam(fileUrl, mediaFileName) {
      this.renameCamObj = { fileUrl, mediaFileName }
      this.renamePicObj = {}
      this.renameAudioObj = {}
      this.renameTextObj = {}
      this.popupActive = 'rename'
    },
    //音频重命名
    renameAudio(fileUrl, mediaFileName) {
      this.renameCamObj = {}
      this.renamePicObj = {}
      this.renameTextObj = {}
      this.renameAudioObj = { fileUrl, mediaFileName }
      this.popupActive = 'rename'
    },
    //文本重命名
    renameText(fileUrl, mediaFileName) {
      this.renameCamObj = {}
      this.renamePicObj = {}
      this.renameAudioObj = {}
      this.renameTextObj = { fileUrl, mediaFileName }
      this.popupActive = 'rename'
    },
    //确定重命名
    async confirmReanme(runType) {
      let that = this
      this.popupActive = ''
      let reg_name = /[`~!@#$^&*()=|{}':;',\\[\]<>/?~！@#￥……&*（）——|{}【】'；：""'。，、？\s0e]/g
      let renameVal = this.renameVal.replace(reg_name, ''),
        renamePicObj = this.renamePicObj,
        renameCamObj = this.renameCamObj,
        renameAudioObj = this.renameAudioObj,
        renameTextObj = this.renameTextObj,
        //获取需要重命名积木的对象
        renameObj = renamePicObj.mediaFileName
          ? renamePicObj
          : renameCamObj.mediaFileName
          ? renameCamObj
          : renameAudioObj.mediaFileName
          ? renameAudioObj
          : renameTextObj,
        renameLabel = renamePicObj.mediaFileName
          ? 'MEDIAPIC'
          : renameCamObj.mediaFileName
          ? 'MEDIACAM'
          : renameAudioObj.mediaFileName
          ? 'MEDIAAUDIO'
          : 'MEDIATEXT'
      // console.log('renameTextObj', renameTextObj)
      if (renameObj && renameObj.mediaFileName) {
        let enstr = this.$util.urlToStr.encrypt(renameObj.fileUrl),
          typestrurl =
            renameLabel + enstr + 'mediaFileName=' + renameObj.mediaFileName,
          newTypestrurl = renameLabel + enstr + 'mediaFileName=' + renameVal,
          typeBlocks = this.workspace.getBlocksByType(typestrurl),
          clickTarget = this.elMedia,
          typeBlocksLen = typeBlocks.length,
          nodeList = document.querySelectorAll(
            '.blocklyTreeRow > .blocklyTreeLabel'
          )
        // let allBlocks2 = this.workspace.getAllBlocks();
        // 获取元素，再次定位媒体位置，做二次点击处理
        if (!clickTarget) {
          for (let i = 0, len = nodeList.length; i < len; i++) {
            let node = nodeList[i]
            if (node.textContent.indexOf('媒体') > -1) {
              this.elMedia = clickTarget = node.parentNode
            }
          }
        }
        //调用请求接口
        let res = await this.updateMediaBlock(renameObj, renameVal, renameLabel)
        //手动修改重命名
        if (res.isSuccess) {
          //图片重命名
          if (renameLabel == 'MEDIAPIC') {
            this.picTempList = this.picTempList.map((picTem) => {
              if (picTem.mediaFileUrl == renameObj.fileUrl) {
                picTem = {
                  mediaFileName: renameVal,
                  mediaFileUrl: picTem.mediaFileUrl,
                }
              }
              return picTem
            })
          } else if (renameLabel == 'MEDIACAM') {
            //摄像头重命名
            this.camTempList = this.camTempList.map((camTem) => {
              if (
                camTem.mediaFileUrl == renameObj.fileUrl &&
                camTem.mediaFileName == renameObj.mediaFileName
              ) {
                camTem = {
                  mediaFileName: renameVal,
                  mediaFileUrl: camTem.mediaFileUrl,
                }
              }
              return camTem
            })
          } else if (renameLabel == 'MEDIAAUDIO') {
            //音频重命名
            this.audioTempList = this.audioTempList.map((audioTem) => {
              if (audioTem.mediaFileUrl == renameObj.fileUrl) {
                audioTem = {
                  mediaFileName: renameVal,
                  mediaFileUrl: audioTem.mediaFileUrl,
                }
              }
              return audioTem
            })
          } else if (renameLabel == 'MEDIATEXT') {
            //文本重命名
            this.textTempList = this.textTempList.map((textTem) => {
              if (textTem.mediaFileUrl == renameObj.fileUrl) {
                textTem = {
                  mediaFileName: renameVal,
                  mediaFileUrl: textTem.mediaFileUrl,
                }
              }
              return textTem
            })
          }
          //如果工作台有该积木，进行工作台积木重命名
          if (typeBlocksLen) {
            typeBlocks.map((block) => {
              block.type = newTypestrurl
            })
            this.workspace.addTypedBlock(typeBlocks[0])

            // this.xmlDataUpdate();
            let workspaceXml = Blockly.Xml.workspaceToDom(this.workspace)
            let xmlText = workspaceXml.outerHTML //workspace XMl文本内容
            let allBlocks = this.workspace.getAllBlocks() //获取所有积木
            allBlocks.forEach((block) => {
              block.dispose(false, true)
            })
            // 对新的积木重新生成
            this.createBlocksByWorkspaceXML(xmlText)
            Blockly.Xml.domToWorkspace(workspaceXml, this.workspace)
          }
          this.coloursFlyoutCallback(/* workspace */) //创建媒体类型积木
          clickTarget.click()
          //两次点击
          // setTimeout(() => {
          clickTarget.click()
          // }, 100)
        }
      }
    },
    //修改媒体积木接口
    async updateMediaBlock(renameObj, rename) {
      var self = this,
        findMedia,
        fileUrl = renameObj.fileUrl,
        data,
        mediaId
      findMedia = this.Media.find(
        (item) => item && new RegExp(item.mediaFileUrl).test(fileUrl)
      )
      // console.log(' this.findMedia', findMedia)
      if (findMedia) {
        mediaId = findMedia.mediaId
      } else {
        console.log('mediaId为null')
      }

      data = {
        mediaId: mediaId,
        mediaFileName: rename,
      }
      if (this.trainingId) {
        return BLOCK.updateMedia(data)
      } else {
        return AI_EDITOR.updateMedia(data)
      }
    },

    /**
     *
     *
     * 摄像头功能处理
     *  */
    //创建网络摄像头积木
    confirmNetCamera(netCamera) {
      this.popupActive = '' //关闭弹框
      var mediaFileName = netCamera.name || '摄像头'
      mediaFileName = mediaFileName.replace(/,/, '')
      mediaFileName = mediaFileName.replace(/，/, '')
      var mediaFileUrl = netCamera.url
      var clickTarget = this.elMedia,
        nodeList = document.querySelectorAll(
          '.blocklyTreeRow > .blocklyTreeLabel'
        ) //积木树列表?
      // 获取元素，再次定位媒体位置，做二次点击处理
      if (!clickTarget) {
        for (let i = 0, len = nodeList.length; i < len; i++) {
          let node = nodeList[i]
          if (node.textContent.indexOf('媒体') > -1) {
            this.elMedia = clickTarget = node.parentNode
          }
        }
      }
      let camItem = this.camTempList.filter((item) => {
        return (
          item.mediaFileName == mediaFileName &&
          item.mediaFileUrl == mediaFileUrl
        )
      })
      if (camItem.length > 0) {
        return this.$message.error('已有此摄像头积木，不能重复创建')
      }
      this.camTempList.push({
        mediaFileName: mediaFileName,
        mediaFileUrl: mediaFileUrl,
      })
      this.mediaUpload([
        {
          mediaFileName: mediaFileName,
          mediaFileUrl: mediaFileUrl,
        },
      ])
      //接着对camTempList监听处理，双击打开媒体类别工具箱;
      clickTarget.click()
      setTimeout(() => {
        clickTarget.click()
      }, 10)
    },
  }, // methods end
}
